import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function Pagination({
  totalRecord = 0,
  rowPerPage = 200,
  onPageChange = () => {},
  offset = 0,
}) {
  const numPages = Math.ceil(totalRecord / rowPerPage);
  const initialPage = Math.floor(offset / rowPerPage) + 1;
  const [page, setPage] = useState(initialPage);

  useEffect(() => {
    const newOffset = (page - 1) * rowPerPage;
    onPageChange([newOffset, rowPerPage]);
  }, [page, rowPerPage, onPageChange]);

  useEffect(() => {
    setPage(initialPage);
  }, [totalRecord, offset, rowPerPage, initialPage]);

  const handleSetPage = (newPage) => {
    if (newPage >= 1 && newPage <= numPages && newPage !== page) {
      setPage(newPage);
    }
  };

  const pgNumArr = Array.from({ length: numPages }, (_, i) => i + 1);

  return (
    <div
      className="flex-sec"
      style={{
        margin: '10px 10px',
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      <div>
        {`${1 + (page - 1) * rowPerPage} - ${Math.min(
          page * rowPerPage,
          totalRecord
        )} of ${totalRecord}`}
      </div>
      <div>
        {page > 1 && (
          <>
            <button className="pagination-btn" onClick={() => handleSetPage(1)}>
              {'<<'}
            </button>
            <button
              className="pagination-btn"
              onClick={() => handleSetPage(page - 1)}
            >
              {'<'}
            </button>
          </>
        )}

        {pgNumArr.map((item) => {
          if (
            item === 1 ||
            item === numPages ||
            (item >= page - 1 && item <= page + 1)
          ) {
            return (
              <span
                key={item}
                className={
                  page === item ? 'pagination-btn-dis' : 'pagination-btn'
                }
                onClick={() => handleSetPage(item)}
              >
                {item}
              </span>
            );
          }
          if (
            (item === 2 && page > 4) ||
            (item === numPages - 1 && page < numPages - 3)
          ) {
            return <span key={item}> ... </span>;
          }
          return null;
        })}

        {page < numPages && (
          <>
            <button
              className="pagination-btn"
              onClick={() => handleSetPage(page + 1)}
            >
              {'>'}
            </button>
            <button
              className="pagination-btn"
              onClick={() => handleSetPage(numPages)}
            >
              {'>>'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

Pagination.propTypes = {
  totalRecord: PropTypes.number,
  rowPerPage: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  offset: PropTypes.number,
};

export default Pagination;
